module.exports = {"name":"pandasScheduleRevamp","parameters":[{"name":"isPersonalizedScheduleEnabled","valid":[true,false],"value":false}]}